import { render, staticRenderFns } from "./LicenseStatusBanner.vue?vue&type=template&id=18ecc63f&scoped=true&"
import script from "./LicenseStatusBanner.vue?vue&type=script&lang=js&"
export * from "./LicenseStatusBanner.vue?vue&type=script&lang=js&"
import style0 from "./LicenseStatusBanner.vue?vue&type=style&index=0&id=18ecc63f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ecc63f",
  null
  
)

export default component.exports